import { styleVariants, styleOptions } from "./style";

export const getMaxDateOfArray = (dateList) =>
  new Date(Math.max.apply(null, dateList));
export const getMinDateOfArray = (dateList) =>
  new Date(Math.min.apply(null, dateList));
export const addDays = function (date, days) {
  date = new Date(date);
  date.setDate(date.getDate() + days);
  return date;
};
export const cloneState = (data) => JSON.parse(JSON.stringify(data));
export const twoDigits = (num) => (("" + num).length < 2 ? "0" + num : num);
export const toDate = (val) => new Date(val);
export const getItalianDate = (date) =>
  `${date.getDate()}/${twoDigits(date.getMonth() + 1)}/${date.getFullYear()}`;
export const getDisplayDate = (originalDate, withoutHour) => {
  if (!originalDate) {
    return "";
  }
  originalDate = new Date(originalDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const compDate = new Date(originalDate);
  compDate.setHours(0, 0, 0, 0);
  return `${compDate.getTime() === today.getTime()
    ? "oggi"
    : compDate.getTime() === addDays(today, -1).getTime()
      ? "ieri"
      : getItalianDate(originalDate)
    }${withoutHour
      ? ""
      : ` alle ${twoDigits(originalDate.getHours())}:${twoDigits(
        originalDate.getMinutes()
      )}`
    }`;
};

export const zeroHours = (date) => {
  date = new Date(date);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const getDisplayHour = (originalDate) => {
  if (!originalDate) {
    return "";
  }
  originalDate = new Date(originalDate);
  return `${twoDigits(originalDate.getHours())}:${twoDigits(
    originalDate.getMinutes()
  )}`;
};

export const redirectAfterOwnerLogin = (history, user) => {
  history.push(user.type === "ownerReport" ? "/owner/report" : "/owner/home");
};

export const redirectAfterUserLogin = (history) => {
  const _sessionUrl = sessionStorage.getItem('url');
  if (_sessionUrl) {
    history.push(_sessionUrl);
  } else {
    history.push('/');
  }
};

export const getScrollY = () =>
  window.pageYOffset || document.documentElement.scrollTop;

// export const numberToRGB = (colorNum, colors) => {
//   if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
//   return "hsl(" + ((colorNum * (360 / colors)) % 360) + ",100%,50%)";
// };

export const numberToRGB = (colorNum, colors) => {
  if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
  const angleMultiplier = 3; // Increase the separation angle
  return "hsl(" + ((colorNum * (360 / colors) * angleMultiplier) % 360) + ",100%,50%)";
};


export const toDateTime = (date) =>
  new Date(date).toISOString().slice(0, 19).replace("T", " ");


export const ottieniGiornoMeseAnno = (dataString) => {
  const data = new Date(dataString);
  // Ottieni giorno, mese e anno
  const giorno = data.getDate();
  const mese = String(data.getMonth() + 1).padStart(2, '0'); // Aggiunge uno zero iniziale se necessario
  const anno = data.getFullYear();
  return (giorno + '/' + mese + '/' + anno).toString();
}

// Logica di filtraggio
export const filterForPrintedAndSelectedOption = (data) => {
  const filter = localStorage.getItem('filterRes') || 'tutto';
  return data.map(data => {
    // Filtra le reservations in base al filtro
    const filteredReservations = data.reservations.filter(reservation => {
      if (reservation.printed !== 0) return false; // esclude le prenotazioni già stampate
      if (reservation.accettato === 0) return false; // esclude consegne e ritiro non ancora accettate
      if (filter === 'tutto') return reservation.selected_option === 'cucina' || reservation.selected_option === 'bar' || reservation.selected_option === 'fritti';
      return reservation.selected_option === filter;
    });

    // Se ci sono reservations filtrate, restituisci il tavolo aggiornato, altrimenti null
    return filteredReservations.length > 0 ? { ...data, reservations: filteredReservations } : null;
  }).filter(data => data !== null); // Filtra fuori i tavoli senza reservations

}


export const calcolaOrariDisponibili = (
  futureTimes,
  openingHour, openingMinutes,
  closingHour, closingMinutes,
  currentHour, currentMinutes
) => {
  if (closingHour >= openingHour) {
    // apertura e chiusura nello stesso giorno
    for (let hour = openingHour; hour <= closingHour; hour++) {
      const startMinutes = hour === openingHour ? openingMinutes : 0;
      for (let minutes = startMinutes; minutes < 60; minutes += 15) {
        if (hour === closingHour && minutes > closingMinutes) break;
        if (hour > currentHour || (hour === currentHour && minutes >= currentMinutes)) {
          const formattedHour = (hour % 24).toString().padStart(2, '0');
          const formattedMinutes = minutes.toString().padStart(2, '0');
          futureTimes.push(`${formattedHour}:${formattedMinutes}`);
        }
      }
    }
  } else {
    // attraversamento della mezzanotte

    // primo ciclo: apertura → 23:59
    for (let hour = openingHour; hour < 24; hour++) {
      const startMinutes = hour === openingHour ? openingMinutes : 0;
      for (let minutes = startMinutes; minutes < 60; minutes += 15) {
        if (hour > currentHour || (hour === currentHour && minutes >= currentMinutes) || currentHour < openingHour) {
          const formattedHour = (hour % 24).toString().padStart(2, '0');
          const formattedMinutes = minutes.toString().padStart(2, '0');
          futureTimes.push(`${formattedHour}:${formattedMinutes}`);
        }
      }
    }

    // secondo ciclo: 00:00 → chiusura
    for (let hour = 0; hour <= closingHour; hour++) {
      const startMinutes = 0;
      for (let minutes = startMinutes; minutes < 60; minutes += 15) {
        if (hour === closingHour && minutes > closingMinutes) break;
        const formattedHour = (hour % 24).toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        futureTimes.push(`${formattedHour}:${formattedMinutes}`);
      }
    }
  }
};



export function rimuoviOrariOccupati(orariDisponibili, capacitaProduzione, indiceProduzione) {
  let orariRimasti = [...orariDisponibili]; // Copia immutabile

  // Gestione del caso orario: null
  if (capacitaProduzione.length !== 0 && capacitaProduzione.some(el => el.orario === null)) {
    const itemInCucina = capacitaProduzione.filter(el => el.orario === null);
    const intervalliNecessari = Math.floor(itemInCucina[0].amount / indiceProduzione);
    orariRimasti = orariDisponibili.slice(intervalliNecessari);
  }

  // Gestione di orari precisi
  capacitaProduzione.forEach(item => {
    if (item.orario?.includes("-")) {
      // Caso di intervallo di tempo (es. "13:00 - 13:15")
      let [oraInizio] = item.orario.split(" - ");
      let indexInizio = orariRimasti.indexOf(oraInizio);

      if (indexInizio !== -1) {
        // Calcolare quanti intervalli rimuovere
        const intervalliNecessari = Math.floor(item.amount / indiceProduzione);
        orariRimasti.splice(indexInizio, intervalliNecessari);
      }
    } else {
      // Caso di orario singolo
      let index = orariRimasti.indexOf(item.orario);
      if (index !== -1 && item.amount >= indiceProduzione) {
        // Rimuovi l'orario e i successivi in base alla quantità
        const intervalliNecessari = Math.floor(item.amount / indiceProduzione);
        orariRimasti.splice(index, intervalliNecessari);
      }
    }
  });

  // Verifica la distanza tra i primi due intervalli
  const intervalloMaxDiff = 15; // Max distanza tra intervalli in minuti
  let diff = (new Date(`1970-01-01T${orariRimasti[1]}:00`).getTime() - new Date(`1970-01-01T${orariRimasti[0]}:00`).getTime()) / 60000;

  // Se la differenza tra i primi due intervalli è maggiore di 15 minuti, nascondi l'opzione "prima possibile"
  let mostraPrimaPossibile = true; // Dichiaro la variabile mostraPrimaPossibile

  if (diff > intervalloMaxDiff) {
    mostraPrimaPossibile = false; // Cambia lo stato se l'intervallo è troppo grande
  }

  return {
    mostraPrimaPossibile: mostraPrimaPossibile, // Restituisci lo stato dell'opzione
    //orariRimasti: orariRimasti.slice(1) // Mostra solo gli orari successivi a quelli selezionati
    orariRimasti: orariRimasti
  };
}



export function filtraOrariRitiro(orariDisponibili, ordiniEsistenti, disabledSlots, maxRitiriContemporanei) {
  // 1. Definiamo se il limite è disattivato (0 o > 20)
  const isNoLimit = maxRitiriContemporanei === 0 || maxRitiriContemporanei > 20;

  // 2. Filtriamo gli orari
  const orariRimasti = orariDisponibili.filter(orario => {
    // REGOLA 1: Se lo slot è spento manualmente dall'owner, lo rimuoviamo
    if (disabledSlots && disabledSlots.includes(orario)) return false;

    // REGOLA 2: Se non c'è limite numerico, lo slot è ok
    if (isNoLimit) return true;

    // REGOLA 3: Controllo saturazione slot
    // Cerchiamo nell'array del DB se questo specifico orario ha già degli ordini
    const ordiniPerQuestoSlot = ordiniEsistenti.filter(res => {
      // Puliamo l'orario se arriva come "20:00 - 20:15"
      const orarioDB = res.orario.includes(" - ") ? res.orario.split(" - ")[0] : res.orario;
      return orarioDB === orario;
    });
    const occupati = ordiniPerQuestoSlot.length; // Usiamo la lunghezza dell'array di match

    // Se ho 1 ordine e il limite è 1, "1 < 1" è FALSE -> lo slot sparisce. Corretto.
    return occupati < maxRitiriContemporanei;
  });

  // --- Da qui in poi la tua logica "Prima Possibile" originale ---
  const intervalloMaxDiff = 15;
  let mostraPrimaPossibile = false;

  if (orariRimasti.length >= 2) {
    let diff = (new Date(`1970-01-01T${orariRimasti[1]}:00`).getTime() -
      new Date(`1970-01-01T${orariRimasti[0]}:00`).getTime()) / 60000;

    if (diff <= intervalloMaxDiff && diff >= 0) {
      mostraPrimaPossibile = true;
    }
  } else if (orariRimasti.length === 1) {
    mostraPrimaPossibile = true;
  }

  return { mostraPrimaPossibile, orariRimasti };
}



// I comuni arrivano da un elenco fisso, quindi si confronterebbero anche cosi' come sono:
// normalizzarli non costa nulla e protegge dal giorno in cui l'elenco sara' configurabile.
const normalizzaComune = (comune) => (comune || '').trim().toLowerCase();

export function filtraOrariConsegne(
  orariDisponibili, ordiniEsistenti, disabledSlots, manualUnlocks, maxConsegneExtra,
  comuneCliente, abilitaConsegneStessoComune, maxConsegneStessoComune
) {
  // 1. Filtriamo gli orari con la logica della capacità dinamica
  const orariRimasti = orariDisponibili.filter(orario => {
    // Cerchiamo i dati di questo slot nei conteggi del DB
    const ordiniPerQuestoSlot = ordiniEsistenti.filter(res => {
      const orarioDB = res.orario.includes(" - ") ? res.orario.split(" - ")[0] : res.orario;
      return orarioDB === orario;
    });

    const numeroOrdiniAttuali = ordiniPerQuestoSlot.length; // Usiamo .length invece di .count
    const isRiapertoManualmente = manualUnlocks && manualUnlocks.includes(orario);

    // --- LOGICA DELLE REGOLE ---

    // REGOLA A: Se lo slot è in manualUnlocks, usiamo il limite extra
    if (isRiapertoManualmente) {
      // Resta visibile se gli ordini attuali sono meno del limite extra impostato
      return numeroOrdiniAttuali < (parseInt(maxConsegneExtra) || 1);
    }

    // REGOLA B: Se lo slot è spento dall'owner (e non è riaperto), fuori.
    if (disabledSlots && disabledSlots.includes(orario)) {
      return false;
    }

    // REGOLA C: Slot standard (non riaperto).
    // Slot vuoto: libero per tutti, come è sempre stato.
    if (numeroOrdiniAttuali < 1) return true;

    // Slot già occupato: muore qui, a meno che il gestore abbia acceso le consegne
    // aggiuntive nello stesso comune.
    if (!Number(abilitaConsegneStessoComune)) return false;

    if (numeroOrdiniAttuali >= (parseInt(maxConsegneStessoComune) || 0)) return false;

    // Il paese di chi occupa già lo slot. Se manca il comune su una delle consegne,
    // o se nello slot sono finiti paesi diversi, non ci si aggiunge.
    const comuniOccupanti = ordiniPerQuestoSlot.map(res => normalizzaComune(res.comune));
    if (comuniOccupanti.some(comune => !comune)) return false;
    const paeseSlot = comuniOccupanti[0];
    if (!comuniOccupanti.every(comune => comune === paeseSlot)) return false;

    // Comune del cliente non ancora noto: è il caso della porta d'ingresso del form e
    // delle vetrine (landing e menu). Lo slot si mostra perché esiste un paese per cui
    // è disponibile; chi non è di quel paese lo vedrà sparire al passaggio dell'orario,
    // quando il comune sarà noto.
    const comuneMio = normalizzaComune(comuneCliente);
    if (!comuneMio) return true;

    return comuneMio === paeseSlot;
  });

  // 2. Logica "Prima Possibile" (Invariata, usa i nuovi orariRimasti)
  const intervalloMaxDiff = 15;
  let mostraPrimaPossibile = false;

  if (orariRimasti.length >= 2) {
    let diff = (new Date(`1970-01-01T${orariRimasti[1]}:00`).getTime() -
      new Date(`1970-01-01T${orariRimasti[0]}:00`).getTime()) / 60000;

    if (diff <= intervalloMaxDiff && diff >= 0) {
      mostraPrimaPossibile = true;
    }
  } else if (orariRimasti.length === 1) {
    mostraPrimaPossibile = true;
  }

  return { mostraPrimaPossibile, orariRimasti };
}





export const isOpen = (currentTimeDB, openingTime, closingTime) => {
  const [openHours, openMinutes, openSeconds] = openingTime.split(':').map(Number);
  const [closeHours, closeMinutes, closeSeconds] = closingTime.split(':').map(Number);

  const now = currentTimeDB;
  const splittedTime = now.split(':')
  const currentHours = Number(splittedTime[0]);
  const currentMinutes = Number(splittedTime[1]);
  // const currentSeconds = Number(splittedTime[2].substring(0, 3).trim());

  const openTime = new Date();
  openTime.setHours(openHours, openMinutes, openSeconds, 0);

  const closeTime = new Date();
  closeTime.setHours(closeHours, closeMinutes, closeSeconds, 0);

  const currentTime = new Date();
  currentTime.setHours(currentHours, currentMinutes, 0, 0);

  if (closeTime < openTime) {
    // Locale aperto a cavallo della mezzanotte
    return currentTime >= openTime || currentTime < closeTime;
  } else {
    // Locale aperto nello stesso giorno
    return currentTime >= openTime && currentTime < closeTime;
  }
}

export const getFees = (amount) => {
  const stripeFees = (amount * 0.0325) + 0.25;
  const stripeIva = stripeFees * 0.22;
  const myOrdersFees = (amount * 0.005) + 0.10;
  return (stripeFees + stripeIva + myOrdersFees);


}

export const calculateTotalWithFees = (netAmount, isReturnFees, paymentOption) => {
  const stripePercentage = 0.015; // 1.50%
  const stripeFixed = 0.25; // €0.25 fixed fee
  const stripeIva = 0.22; // 22% IVA

  const myPercentage = 0.01; // 1%
  const myFixed = 0.25; // €0.25 fixed fee

  if (paymentOption?.toLowerCase() === 'carta') {
    if (isReturnFees) {
      return (((netAmount + stripeFixed * (1 + stripeIva) + myFixed) /
        (1 - (stripePercentage * (1 + stripeIva) + myPercentage))) - netAmount).toFixed(2);
    } else {
      return ((netAmount + stripeFixed * (1 + stripeIva) + myFixed) /
        (1 - (stripePercentage * (1 + stripeIva) + myPercentage))).toFixed(2);
    }
  } else {
    return netAmount.toFixed(2)
  }
};




export const formatVariants = (variantString, refStyle) => {
  // Split by line breaks to get each category with its options
  if (variantString) {
    const categoryOptionsArray = variantString.split('\n\n').filter(Boolean);
    // Create a formatted list where categories are bolded and options are regular
    return categoryOptionsArray.map((categoryOptions, index) => {
      const [category, options] = categoryOptions.split(': ');
      if (refStyle === undefined) {
        return (
          <div key={index} style={{ marginBottom: '8px' }}>
            <strong style={{ ...styleVariants, fontSize: '16px' }}>{category}:</strong>
            <span style={{ ...styleOptions, fontSize: '14px' }}> {options}</span>
          </div>
        );
      } else {
        return (
          <div key={index} style={{ marginBottom: '8px' }}>
            <span>{category}:</span>
            <strong> {options}</strong>
          </div>
        );
      }

    });
  }
}



export const getSelectedVariantsForPrintView = (variants) => {
  // Creiamo un oggetto per raggruppare le opzioni selezionate
  if (variants === undefined) return null;
  const groupedVariants = {};

  variants.forEach(variant => {
    const { name, position, options, selected } = variant;

    // Inizializziamo l'array per il nome della variante se non esiste già
    if (!groupedVariants[name]) {
      groupedVariants[name] = {
        options: [],
        position: position // Memorizziamo la posizione
      };
    }

    const selectedOptions = options.filter(option => selected.some(sel => sel.id === option.id));
    const selectedOptionNames = selectedOptions.map(option => option.label);
    groupedVariants[name].options.push(...selectedOptionNames); // Aggiungiamo le opzioni selezionate all'array corrispondente

  });

  // Ordiniamo le varianti in base alla posizione
  const sortedVariants = Object.entries(groupedVariants).sort((a, b) => {
    return a[1].position - b[1].position; // Ordina per posizione
  })

  // Ora convertiamo l'oggetto in una stringa formattata
  return sortedVariants.map(([variantName, { options }]) => {
    return `${variantName}: ${options.join(', ')}`; // Uniamo le opzioni selezionate con una virgola
  }).join('\n\n');


};



export const orderByFirstUpdate = (tables) => tables.sort((table1, table2) => {
  const lastUpdate1 = getMinDateOfArray(
    table1.reservations.map(({ lastUpdate }) => toDate(lastUpdate))
  );
  const lastUpdate2 = getMinDateOfArray(
    table2.reservations.map(({ lastUpdate }) => toDate(lastUpdate))
  );

  return lastUpdate1.getTime() - lastUpdate2.getTime();
});


export const orderByTime = (tables) => tables.sort((table1, table2) => {
  const time1 = toTime(table1.orario);
  const time2 = toTime(table2.orario);

  return time1 - time2;
});

// Funzione per convertire l'orario in minuti (per confronto più facile)
export const toTime = (timeStr) => {
  if (!timeStr || typeof timeStr !== 'string') return 0; // Se manca, lo spostiamo in fondo

  const cleanTime = timeStr.split(' - ')[0]; // Prende solo l'orario iniziale in caso di intervallo
  const [hours, minutes] = cleanTime.split(':').map(Number);

  let totalMinutes = (hours || 0) * 60 + (minutes || 0);

  // Se l'orario è tra mezzanotte e le 05:00, lo consideriamo "del giorno successivo"
  if (hours >= 0 && hours < 4) {
    totalMinutes += 1440; // Aggiungiamo 24 ore in minuti
  }

  return totalMinutes;
};



export const validateFormData = ({ name, surname, phoneNumber, address, city, email, deliveryOption, optionTime, deliveryTime, showTime }) => {

  const errors = {};
  let formIsValid = true;

  if (!name) {
    errors.name = true;
    formIsValid = false;
  }

  if (!surname) {
    errors.surname = true;
    formIsValid = false;
  }

  if (!deliveryOption) {
    errors.deliveryOption = true;
    formIsValid = false;
  }

  if (!phoneNumber) {
    errors.phoneNumber = true;
    formIsValid = false;
  }

  if (deliveryOption === 'Consegna') {
    if (!address) {
      errors.address = true;
      formIsValid = false;
    }
    if (!city) {
      errors.city = true;
      formIsValid = false;
    }
  }

  if (!optionTime && showTime) {
    errors.optionTime = true;
    formIsValid = false;
  }

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email) {
    errors.email = true;
    formIsValid = false;
  } else if (!emailRegex.test(email)) {
    errors.validEmail = true;
    formIsValid = false;
  }

  if (!deliveryTime && optionTime === 'impostaOrario' && showTime) {
    errors.deliveryTime = true;
    formIsValid = false;
  }

  return { formIsValid, errors };
};


export const formatEuro = (value) => {
  if (typeof value !== 'number' || isNaN(value)) return '0,00 €';
  return value.toFixed(2).replace('.', ',') + ' €';
};

export const safeToFixed = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return '0,00';

  return num.toLocaleString('it-IT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};